// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__VsY5b","col":"footer_col__VPJT2","flex":"footer_flex__hILzA","copy":"footer_copy__k40yO","icon":"footer_icon__yQOns","link":"footer_link__rOat4"};